export default String.raw`
window.addEventListener('comparer:added', async (e) => {
    const productId = e.detail.productId;
    const button = document.querySelector('.add-to-comparison-js[data-product-id="' + productId + '"]');

    if (!button) {
        return;
    }

    const span = button.querySelector('span');
    if (span) {
        span.innerText = __translations.Delete;
    }

    button.classList.replace('add-to-comparison-js', 'remove-from-comparison-js');
});

window.addEventListener('comparer:removed', (e) => {
    const productId = e.detail.productId;
    const button = document.querySelector('.remove-from-comparison-js[data-product-id="' + productId + '"]');

    if (!button) {
        return;
    }
    
    const span = button.querySelector('span');
    if (span) {
        span.innerText = __translations.Compare;
    }
    button.classList.replace('remove-from-comparison-js', 'add-to-comparison-js');
});

$(document).ready(() => {
    if ($('.product-presentation-js').length > 0) {
        productDetails.init();
    }
});

let zoomSwiper = null;

const productDetails = {
    scrollingManually: false,

    nav: {
        bar: document.querySelector('.product-presentation-menu-js'),
        topSection: document.querySelector('.product-presentation__top-section')
    },

    init() {
        this.resetNavElements();
        this.initProductPresentationImageSlider();
        this.initStickyBar();
        this.setupScrollTracking();
        this.bindEvents();
        this.zoomOnProductImage();
        this.initNavSlider();
        graphicalVariantPopup.init();
    },

    initNavSlider(targetIndex = 0) {
        const prevArrow = $('.nav__prev');
        const nextArrow = $('.nav__next');

        const toggleArrowsVisibility = () => {

            if (window.innerWidth < 1440) {
                prevArrow.hide();
                nextArrow.hide();
            } else {
                prevArrow.css('display', 'flex');
                nextArrow.css('display', 'flex');
            }
        };
        
        toggleArrowsVisibility();
    
        window.addEventListener('resize', toggleArrowsVisibility);
        if ($('.nav__wrapper').length > 2) {
            navSwiper = new Swiper(".nav__swiper", {
                navigation: {
                    nextEl: '.nav__next',
                    prevEl: '.nav__prev',
                },
                slidesPerView: 'auto',
                setWrapperSize: true,
                freeMode: true,
                allowTouchMove: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                scrollOnFocus: true,
                speed: 500,
                on: {
                    click() {
                        navSwiper.slideTo(this.clickedIndex);    
                    },
                }
            });
        
            const currentIndex = navSwiper.activeIndex;
            if (targetIndex > currentIndex) {
                navSwiper.slideNext();
            } else if (targetIndex < currentIndex) {
                navSwiper.slidePrev();
            } else {
                navSwiper.slideTo(currentIndex);
            }
        } else {
            navSwiper = null;
            prevArrow.hide();
            nextArrow.hide();
        }
    },

    resetNavElements() {
        this.nav.bar = document.querySelector('.product-presentation-menu-js');
        this.nav.topSection = document.querySelector('.product-presentation__top-section');
    },

    scrollToParagraph(e) {
        if (this.scrollingManually) {
            return;
        }
        
        this.scrollingManually = true;
        const targetSelector = $(e.currentTarget).data('scroll-to-paragraph');

        $('[data-scroll-to-paragraph]').removeClass('nav-item-active');
        $(e.currentTarget).addClass('nav-item-active');

        const $target = $(targetSelector);
        const menuHeight = $(this.nav.bar).outerHeight();
        const headerHeight = $('.header-js').outerHeight();

        if ($target.length) {
            let targetScrollTop;
            if (window.innerWidth < 768) {
                targetScrollTop = $target.offset().top - menuHeight + 8;
            } else {
                targetScrollTop = $target.offset().top - menuHeight - headerHeight + 16;
            }

            const release = () => { this.scrollingManually = false; };
            const safetyTimeout = setTimeout(release, 900);

            $('html, body').animate({ scrollTop: targetScrollTop }, 500, () => {
                clearTimeout(safetyTimeout);
                release();
            });
        } else {
            this.scrollingManually = false;
        }
    },

    setupScrollTracking() {
        const updateHeights = () => {
            this.menuHeight = $(this.nav.bar).outerHeight();
            this.headerHeight = $('.header-js').outerHeight();
        };
    
        updateHeights();
    
        const navItems = $('[data-scroll-to-paragraph]');
        let ticking = false;
        let lastActiveIndex = -1;
        
        const findMostVisibleSection = () => {
            const viewportHeight = window.innerHeight;
            let maxVisibleArea = 0;
            let mostVisibleSection = null;
            let mostVisibleIndex = -1;
            
            navItems.each(function(index) {
                const targetSelector = $(this).data('scroll-to-paragraph');
                const $section = $(targetSelector);
                
                if ($section.length) {
                    const rect = $section[0].getBoundingClientRect();
                    
                    const sectionTop = Math.max(0, rect.top);
                    const sectionBottom = Math.min(viewportHeight, rect.bottom);
                    const visibleArea = Math.max(0, sectionBottom - sectionTop);
                    
                    if (visibleArea > maxVisibleArea) {
                        maxVisibleArea = visibleArea;
                        mostVisibleSection = $(this);
                        mostVisibleIndex = index;
                    }
                }
            });
            
            if (mostVisibleSection === null && navItems.length > 0) {
                mostVisibleSection = navItems.first();
                mostVisibleIndex = 0;
            }
            
            return { 
                section: mostVisibleSection, index: mostVisibleIndex 
            };
        };
    
        $(window).on('scroll', () => {
            if (this.scrollingManually) {
                return;
            }

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const { section: activeTab, index: activeIndex } = findMostVisibleSection();
                    
                    if (activeTab && activeTab.length) {
                        navItems.removeClass('nav-item-active');
                        activeTab.addClass('nav-item-active');
                        
                        if (typeof navSwiper !== 'undefined' && navSwiper !== null) {
                            if (activeIndex !== lastActiveIndex) {
                                lastActiveIndex = activeIndex;
                                navSwiper.slideTo(activeIndex);
                            }
                        }
                    }
                    
                    ticking = false;
                });
                ticking = true;
            }
        });
        
        $(window).on('load', () => {
            this.scrollingManually = false;
        });
        
    const userRelease = () => { this.scrollingManually = false; };
    $(window).on('wheel touchmove mousewheel keydown mousedown touchstart', userRelease);
        
        setTimeout(() => {
            this.scrollingManually = false;
            $(window).trigger('scroll');
        }, 300);
    
        const headerObserver = new MutationObserver(() => updateHeights());
        const header = document.querySelector('header');
        headerObserver.observe(header, { attributes: true, childList: true, subtree: true });
    },

    openSetElementProductsPopup: function(setElementId) {
        $('[data-set-element-products-popup='+setElementId+']').removeClass('hidden-js');
		$('body').addClass('modal-opened');
    },

    changeSetElementProduct: function(e) {
        const setElementId = $(e.currentTarget).parents('[data-set-element-products-popup]').data('set-element-products-popup');
        const setProductId = $(e.currentTarget).data('set-product-id');
        const form = $(e.currentTarget).parents('.form-js');
        form.find('[data-set-element-id='+setElementId+']').addClass('set-product-hidden-js');
        form.find('[data-set-element-id='+setElementId+'][data-set-product-id='+setProductId+']').removeClass('set-product-hidden-js');
        let oldPrice = 0;
        let newPrice = 0;
        form.find('.set-product-js:not(.set-product-hidden-js)').each(function(){
            oldPrice = Number((Number(oldPrice) + Number($(this).data('set-product-previous-value').replace(',','.'))).toFixed(__decimalPlacesPrice));
            newPrice = Number((Number(newPrice) + Number($(this).data('set-product-value').replace(',','.'))).toFixed(__decimalPlacesPrice));
        });
        const savedMoney = Number((newPrice - oldPrice).toFixed(__decimalPlacesPrice));
		form.find('.old-price-js .value-js').html(oldPrice.toPrice());
		form.find('.saved-money-js .value-js').html(savedMoney.toPrice());
		form.find('.brutto-js .value-js').html(newPrice.toPrice());
		form.find('.netto-js .value-js').html(newPrice.toPrice());
		$('body').removeClass('modal-opened');
    },

    colorTab: function(){
        let description = 0;
        if($('.product-description-js').index() != -1){
            description = $('.product-description-js').offset().top;
        }
        const attributes = $('.product-attributes-js').offset().top;
        let downloads = 0;
        if($('.downloads-js').index() != -1){
            downloads = $('.downloads-js').offset().top;
        }
        let sets = 0;
        if($('.sets-js').index() != -1){
            sets = $('.sets-js').offset().top;
        }
        let related = 0;
        if($('.related-js').index() != -1){
            related = $('.related-js').offset().top;
        }
        const scroll = $(window).scrollTop();
        if(scroll >= related){
            $('.product-presentation-menu-js li').removeClass('active-js');
            $('[data-scroll-to-element=".related-js"]').addClass('active-js');
        } else if(scroll >= sets){
            $('.product-presentation-menu-js li').removeClass('active-js');
            $('[data-scroll-to-element=".sets-js"]').addClass('active-js');
        } else if(scroll >= downloads){
            $('.product-presentation-menu-js li').removeClass('active-js');
            $('[data-scroll-to-element=".downloads-js"]').addClass('active-js');
        } else if(scroll >= attributes){
            $('.product-presentation-menu-js li').removeClass('active-js');
            $('[data-scroll-to-element=".product-attributes-js"]').addClass('active-js');
        } else if(scroll >= description){
            $('.product-presentation-menu-js li').removeClass('active-js');
            $('[data-scroll-to-element=".product-description-js"]').addClass('active-js');
        } else {
            $('.product-presentation-menu-js li').removeClass('active-js');
        }
    },

    bindEvents() {
        $('body').on('click', '[data-scroll-to-paragraph]', (e) =>
            this.scrollToParagraph(e)
        );

        $('body').on('click', '.open-set-element-products-popup-js', function(e) {
			this.openSetElementProductsPopup($(e.currentTarget).parents('[data-set-element-id]').data('set-element-id'));
		});

        $('body').on('click', '.change-set-element-product-js', function(e) {
			this.changeSetElementProduct(e);
		});

        if($('.product-presentation-menu-js').index() != -1){
			$(window).on('scroll', function () {
				productDetails.colorTab();
			});
		}
    },

    initStickyBar() {
        if (!this.nav.bar || !this.nav.topSection) {
            return;
        }
        
        const header = document.querySelector('header');
        if (!header) {
            return;
        }
        
        $(this.nav.bar).addClass('nav-not-attached-js').removeClass('nav-attached-js');
        this.nav.bar.style.removeProperty('top');
        $('.product-label').css('display', 'none');
        if ($('.nav__wrapper').length < 2) {
            $('.nav__swiper').hide();
        }

        const updateTopPosition = (isAttached) => {
            if (isAttached) {
                if (header.classList.contains('fixed')) {
                    this.nav.bar.style.top = header.offsetHeight + 'px';
                } else {
                    this.nav.bar.style.top = '0px';
                }
            } else {
                this.nav.bar.style.removeProperty('top');
            }
        };

        window.addEventListener('load', () => {
            window.addEventListener('scroll', () => {
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                const topSectionBottom = this.nav.topSection.getBoundingClientRect().bottom + scrollTop;
                
                if (scrollTop > topSectionBottom) {
                    if (!$(this.nav.bar).hasClass('nav-attached-js')) {
                        $(this.nav.bar).addClass('nav-attached-js').removeClass('nav-not-attached-js');
                        $('.nav__swiper').show();
                        $('.product-label').css('display', 'flex');
                        $('.fixed').css('box-shadow', 'none');
                        $('.comparison__bar').css('box-shadow', 'none');
                        updateTopPosition(true);
                    }
                } else {
                    if (!$(this.nav.bar).hasClass('nav-not-attached-js')) {
                        $(this.nav.bar).addClass('nav-not-attached-js').removeClass('nav-attached-js');
                        $('.product-label').css('display', 'none');
                        $('[data-scroll-to-paragraph]').each(function() {
                            $(this).removeClass('nav-item-active');
                        });
                        $('.fixed').css('box-shadow', '');
                        $('.comparison__bar').css('box-shadow', '');
                        if ($('.nav__wrapper').length < 2) {
                            $('.nav__swiper').hide();
                        }
                        updateTopPosition(false);
                    }
                }
            });
        });
        
        const mutationObserver = new MutationObserver(() => {
            if ($(this.nav.bar).hasClass('nav-attached-js')) {
                updateTopPosition(true);
            }
        });

        mutationObserver.observe(header, { attributes: true, childList: true, subtree: true });
    },

    initProductPresentationImageSlider() {
        const SELECTORS = {
            THUMBNAILS: ".multi-image__swiper",
            GALLERY: ".single-image__swiper"
        };
        
        const gallerySlider = document.querySelector(SELECTORS.GALLERY);
        const thumbnailsSlider = document.querySelector(SELECTORS.THUMBNAILS);
        
        if (!gallerySlider) {
            return;
        }
        
        let thumbnailsSwiper = null;
        
        if (thumbnailsSlider && thumbnailsSlider.querySelectorAll('.swiper-slide').length > 0) {
            thumbnailsSwiper = new Swiper(thumbnailsSlider, {
                lazy: true,
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: ".multi-image__next",
                    prevEl: ".multi-image__prev"
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: __translations.PrevSlide,
                    nextSlideMessage: __translations.NextSlide
                }
            });
        }
        
        const galleryOptions = {
            lazy: true,
            spaceBetween: 50,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            keyboard: {
                enabled: true,
                pageUpDown: true
            },
            a11y: {
                enabled: true,
                prevSlideMessage: __translations.PrevSlide,
                nextSlideMessage: __translations.NextSlide
            },
            breakpoints: {
                769: {
                    navigation: {
                        nextEl: ".single-image__next",
                        prevEl: ".single-image__prev"
                    },
                    pagination: {
                        el: null,
                    }
                }
            },
            on: {
                init: function () {
                    app.manageTabIndexInsideSlide(this);
                    if (thumbnailsSwiper) {
                        app.changeSlideOnPaddingSwiper(thumbnailsSwiper, this);
                    }

                },
                slideChangeTransitionEnd: function () {
                    app.manageTabIndexInsideSlide(this);
                    const closeButton = $('.single-image-js').find('.close-zoom-js');
                    if (!closeButton.hasClass('hidden-js')) {
                        app.resetLockFocus(() => closeButton.trigger('click'), false);
                    }
                },
            }
        };
        
        if (thumbnailsSwiper) {
            galleryOptions.thumbs = {
                swiper: thumbnailsSwiper
            };
        }
        
        const gallerySwiper = new Swiper(gallerySlider, galleryOptions);
        
        if (thumbnailsSwiper) {
            thumbnailsSwiper.on('slideChange', function() {
                gallerySwiper.slideTo(thumbnailsSwiper.activeIndex);
            });
            
            gallerySwiper.on('slideChange', function() {
                thumbnailsSwiper.slideTo(gallerySwiper.activeIndex);
            });
        }
    },
    
    zoomOnProductImage() {
        const imageToZoom = $('.single-image-js');
        const closeButton = imageToZoom.find('.close-zoom-js');
        imageToZoom.find('.zoom-btn-js').on('click', (e) => {
            imageToZoom.addClass('zoomed-js');
            closeButton.removeClass('hidden-js');
            $(e.currentTarget).attr('tabindex', '-1');
            app.setLockFocus(imageToZoom, () => closeButton.trigger('click'), $(e.currentTarget));
        });

        closeButton.on('click', (e) => {
            imageToZoom.find('.zoom-btn-js').attr('tabindex', '0');
            $(e.currentTarget).addClass('hidden-js');
            imageToZoom.removeClass('zoomed-js');
            app.offLockFocus();
        });
    }
};

window.initRelatedSlider = function() {
    document.querySelectorAll('.related__swiper').forEach(swiperContainer => {
        const numberOfSlides = swiperContainer.querySelectorAll('.swiper-slide').length;
        const maskRight = $(swiperContainer).closest('.related').find('.mask-right');
        const prevArrow = $(swiperContainer).closest('.related').find('.related__prev');
        const nextArrow = $(swiperContainer).closest('.related').find('.related__next');

        const toggleArrowsVisibility = () => {
            if (window.innerWidth < 1440) {
                prevArrow.hide();
                nextArrow.hide();
                maskRight.hide();
            } else {
                prevArrow.css('display', 'flex');
                nextArrow.css('display', 'flex');
                if (numberOfSlides < 5) {
                    prevArrow.hide();
                    nextArrow.hide();
                    maskRight.hide();
                } else {
                    prevArrow.show();
                    nextArrow.show();
                    maskRight.show();
                }
            }
        };

        toggleArrowsVisibility();

        window.addEventListener('resize', toggleArrowsVisibility);

        new Swiper(swiperContainer, {
            navigation: {
                nextEl: nextArrow[0],
                prevEl: prevArrow[0],
            },
            spaceBetween: 8,
            centerInsufficientSlides: true,
            setWrapperSize: true,
            freeMode: true,
            speed: 500,
            breakpoints: {
                0: {
                    loop: (numberOfSlides > 2),
                    spaceBetween: 16,
                    slidesPerView: 1.2,
                },
                769: {
                    loop: (numberOfSlides > 3),
                    spaceBetween: 24,
                    slidesPerView: 3,
                },
                1440: {
                    loop: (numberOfSlides > 4),
                    spaceBetween: 24,
                    slidesPerView: 4,
                }
            },
        });
    });
};

window.initSetSlider = function() {
    document.querySelectorAll('.sets-details').forEach(container => {
        const $container = $(container);
        const maskLeft = $container.find('.mask-left');
        const maskRight = $container.find('.mask-right');
        const prevArrow = $container.find('.sets__prev');
        const nextArrow = $container.find('.sets__next');
        const swiperEl = $container.find(".sets__swiper")[0];

        const toggleArrowsVisibility = () => {
            if (window.innerWidth < 1440) {
                prevArrow.hide();
                nextArrow.hide();
            } else {
                prevArrow.css('display', 'flex');
                nextArrow.css('display', 'flex');
            }
        };

        toggleArrowsVisibility();

        window.addEventListener('resize', toggleArrowsVisibility);

        const toggleGradientVisibility = (swiper) => {
            if (swiper.isBeginning) {
                maskLeft.hide(300);
            } else {
                maskLeft.show(300);
            }

            if (swiper.isEnd) {
                maskRight.hide(300);
            } else {
                maskRight.show(300);
            }
        };

        new Swiper(swiperEl, {
            navigation: {
                nextEl: '.sets__next',
                prevEl: '.sets__prev',
            },
            slidesPerView: 'auto',
            spaceBetween: 8,
            watchSlidesProgress: true,
            slideToClickedSlide: false,
            centerInsufficientSlides: true,
            setWrapperSize: true,
            freeMode: true,
            speed: 500,

            on: {
                init: function () {
                    toggleGradientVisibility(this);
                },
                slideChange: function () {
                    toggleGradientVisibility(this);
                },
                reachBeginning: function () {
                    toggleGradientVisibility(this);
                },
                reachEnd: function () {
                    toggleGradientVisibility(this);
                },
            },
        });
    });
};

$(document).ready(() => {
    if ($('.sets-container').length > 0) {
        if (typeof window.initSetSlider === 'function') {
            window.initSetSlider();
        }
    }

    if ($('.related-container').length > 0) {
        if (typeof window.initRelatedSlider === 'function') {
            window.initRelatedSlider();
        }
    }
});

$('body').on('click', '.show-size-chart-popup-js', function() {
    document.querySelector('.sizeChart-popup-js').showModal();
});

$('body').on('click', '.show-add-review-popup-js', function() {
    document.querySelector('.add-review-popup-js').showModal();
});

if(document.getElementsByClassName('product-presentation-js').length > 0){
    if (__productIsInCart == 'productIsInCart-yes') {
        const productId = parseInt($('#isInCartId').eq(0).val());
        app.getProductsIdsFromCart(function(res) {
            const productsInCart = res;
            const isInCart = app.checkIfProductIsInCart(productsInCart, productId);
            app.enableDisableInCartButton(isInCart);

        });
    }
}
`